import { render, staticRenderFns } from "./TeachingFilter.vue?vue&type=template&id=bf434d84&scoped=true&"
import script from "./TeachingFilter.vue?vue&type=script&lang=js&"
export * from "./TeachingFilter.vue?vue&type=script&lang=js&"
import style0 from "./TeachingFilter.vue?vue&type=style&index=0&id=bf434d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf434d84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
